import { Card, CardContent, Divider, Grid, Box } from "@mui/material";
import { memo } from "react";
import { colors, jobColors, alphaVar } from "../../../ui/colors";
import { useJobProgress } from "./hooks/useJobProgress";
import { JobCardClient, JobCardDates, JobCardHeader, JobCardLocation, JobCardStatus, JobEventTimeline } from "./components";
import { JobCardWorkforce } from "./components/JobCardWorkforce";

interface Props {
  job: any;
  showWorkforce?: boolean;
  onJobUpdated?: () => void;
}

const determineIsResidential = (job: any, scopeOfWork?: any): boolean => {
  const category = scopeOfWork?.category?.type || job?.client?.type || "";
  const normalized = category.toLowerCase();
  if (normalized.includes("residential") || normalized.includes("residencial")) return true;
  return false;
};

export const JobCard = memo(function JobCard({ job, showWorkforce = true, onJobUpdated }: Props) {
  console.count("render JobCard");
  console.count(`render JobCard ${job?.id}`);

  const company = job.company || job.quote?.company;
  const client = job.client || job.quote?.client;
  const coverage = job.coverageArea || job.quote?.coverageArea;
  const scopeOfWork = job.scopeOfWork;

  const startDate = job?.events?.[0]?.startDate || job?.startDate;
  const endDate = job?.events?.[0]?.endDate || job?.endDate;
  const jobStatus = job?.events?.[0]?.status ?? job?.status;
  const events = job?.events;

  const status = jobColors[jobStatus] || jobColors.forRevision;
  const isResidential = determineIsResidential(job, scopeOfWork);
  const { jobProgress } = useJobProgress(job);

  return (
    <Card
      sx={{
        width: "100%",
        borderRadius: "16px",
        bgcolor: "background.paper",
        border: `1px solid ${alphaVar(colors.gray[100], 0.55)}`,
        transition: "0.2s",
        boxShadow: "none",
        "&:hover": { transform: "translateY(-2px)" },
      }}
    >
      <CardContent sx={{ p: 3, position: "relative" }}>
        <Grid container spacing={1} sx={{ alignItems: "center", pr: { xs: 0, sm: 22 } }}>
          <JobCardHeader company={company} job={job} workScope={scopeOfWork} isResidential={isResidential} onJobUpdated={onJobUpdated} />
          <Box
            sx={{
              display: "flex",
              gap: 1,
              alignItems: { xs: "baseline", sm: "center" },
              justifyContent: { xs: "center", sm: "flex-end" },
              flexDirection: { xs: "column", sm: "row" },
              position: { xs: "static", sm: "absolute" },
              top: { sm: 25 },
              right: { sm: 88 },
            }}
          >
            <JobCardStatus jobStatus={jobStatus} status={status} jobProgress={jobProgress} />
          </Box>
        </Grid>

        <Divider sx={{ my: 2 }} />

        <Grid container spacing={5}>
          <Grid item xs={12} md={4}>
            <JobCardDates createdAt={job.createdAt} startDate={startDate} endDate={endDate} />
            <JobCardLocation coverage={coverage} />
            <JobCardClient client={client} />
          </Grid>

          {showWorkforce && (
            <Grid item xs={12} md={4}>
              <JobCardWorkforce events={events} />
            </Grid>
          )}
          <Grid item xs={12} md={showWorkforce ? 4 : 8}>
            <JobEventTimeline events={events} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});
